<template>
  <v-dialog
    :value="value" @input="$emit('input')"
    width="990"
    content-class="edit-mail-template"
  >

    <v-card class="edit-mail-template-dialog">
      <v-card-title class="text-h5 pt-2">
        <slot name="title">
          Copy Mail Templates:
        </slot>
        {{ from.selected.length }}
      </v-card-title>

      <v-card-text>

        <v-row>
          <v-col cols="6" class="py-0">
            <h3>From</h3>
            <v-divider class="col-12 pa-0 ma-0" />

            <v-data-table
              v-model="from.selected"
              :headers="headers"
              :items="templateList"
              :loading="loading"
              :disable-pagination="true"
              fixed-header
              hide-default-footer
              item-key="template_id"
              class="mail-template-dt"
              sort-by="language"
              show-select
              :search="from.search"
              :height="`calc(100vh - 315px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
            >
              <template v-slot:top>

                <v-row>
                  <select-project
                    v-model="from.entity_id"
                    class="col-8"
                  ></select-project>

                  <v-select
                    v-model="filters.language"
                    :items="languages"
                    label="Language"
                    required
                    hide-details
                    class="col-4"
                    style="z-index: 800"
                  ></v-select>

                  <v-text-field
                    label="Search"
                    v-model="from.search"
                    hide-details
                    dense
                    class="col-12 pt-1 pb-1"
                  />
                </v-row>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="6" class="py-0">
            <h3>To</h3>
            <v-divider class="col-12 pa-0 ma-0" />
            <v-row>
              <template v-if="isShowToProject">
                <select-project
                  class="col-8"
                  v-model="to.entity_id"
                  required
                  :return-object="false"
                />

                <v-select
                  class="col-4"
                  v-model="to.language"
                  :items="$store.state.auth.languages"
                  label="New Language"
                  clearable
                  hide-details
                />
              </template>

            </v-row>

            <v-simple-table
              dense
              fixed-header
              :height="`calc(100vh - 280px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Replace From
                    </th>
                    <th class="text-left">
                      Replace To
                    </th>
                    <th class="text-right">
                      <v-icon
                        @click="to.replace.push({from: '', to: ''})"
                      >mdi-plus
                      </v-icon>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, k) in to.replace">
                    <tr v-if="item">
                      <td>
                        <v-text-field
                          v-model="to.replace[k].from"
                          hide-details
                          class="mb-2"
                          placeholder="From"
                          dense
                        />
                      </td>
                      <td>
                        <v-text-field
                          v-model="to.replace[k].to"
                          hide-details
                          class="mb-2"
                          placeholder="To"
                          dense
                        />
                      </td>
                      <td class="text-right">
                        <v-icon
                          color="error"
                          @click="removeReplace(k)"
                        >mdi-minus-circle-outline
                        </v-icon>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>


      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="warning"
          text
          @click.native="$emit('input')"
        >
          Close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="save"
          :disabled="isShowToProject ? !to.entity_id : false"
        >
          <slot name="button">Copy</slot>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>
  .v-dialog > .edit-mail-template-dialog.v-card > .v-card__text {
    padding: 0 15px 5px;
  }

  .edit-mail-template {
    min-height: calc(100vh - 85px);
  }

  .edit-mail-template-dialog td,
  .edit-mail-template-dialog th {
    padding: 0 8px !important;
  }

  .wrap-anywhere {
    overflow-wrap: anywhere;
  }
</style>

<script>

  import { API } from '@/utils/api'
  import { map, startCase } from 'lodash'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    props: {
      value: { default: false },
      languages: {
        type: Array,
        default: () => ([])
      },
      method: {
        type: String,
        default: 'copy'
      },
      isShowToProject: {
        type: Boolean,
        default: false
      }
    },

    components: { SelectProject },

    data: () => ({
      loading: false,
      from: {
        entity_id: null,
        selected: [],
        search: '',
        items: []
      },
      to: {
        replace: [],
        language: null,
        entity_id: null,
      },
      filters: { language: 'all' },
      headers: [
        { text: 'ID', value: 'template_id', sortable: true },
        { text: 'Language', value: 'languages', sortable: true, cellClass: 'wrap-anywhere' },
        { text: 'Name', align: 'left', sortable: false, value: 'name' },
      ],
      loadingTemplate: true,
    }),

    computed: {
      templateList () {
        return this.from.items.filter(item => {
          return Object.keys(this.filters).every(filter => {
            return (this.filters[filter] === 'All' || item.translation.find(({ language }) => language === this.filters[filter]))
          })
        })
      },
    },

    mounted () {
      this.filters.language = 'All'
    },

    watch: {
      value () {
        if (this.value) {
          this.from.selected = []
          this.from.search = ''
          this.from.items = []
          this.from.entity_id = this.$store.state.auth.entities[0].entity_id

          this.to.replace = []
          this.to.language = null
          this.to.entity_id = null
        } else {
          this.from.entity_id = null
        }
      },
      'from.entity_id' (val) {
        this.from.entity_id = val
        this.loadMailTemplates()
      }
    },

    methods: {

      removeReplace (index) {
        this.to.replace = [ ...this.to.replace ]
        this.to.replace[index] = null
      },

      loadMailTemplates () {
        if (!this.from.entity_id) return
        this.loading = true
        return API.call('/mail/template/list.json', {}, null, this.from.entity_id).then(resp => {
          this.from.items = resp.data.map(item => ({ ...item, languages: item.translation.map(({ language }) => language).join(',') }))
        }).finally(() => {
          this.loading = false
        })
      },

      async save () {
        if (this.from.selected.length == 0 || (this.isShowToProject && !this.to.entity_id)) {

          this.$notification.show = true
          this.$notification.message = `Mail Templates or destination not selected`
          this.$notification.type = 'warning'
          return
        }

        let buttons = [
          { text: 'Save', value: true, class: 'primary darken-1' },
          { text: 'Save and close', value: 'close', class: 'primary darken-1' },
          { text: 'Cancel', value: false, class: 'grey' },
        ]

        let confirmRes = await this.$root.$confirm('Confirm', `${startCase((this.method))} Mail Templates`, { width: 515, buttons })

        if (!confirmRes) {
          return
        }

        this.loading = true
        return API.call(`/mail/template/${this.method}.json`, {
          mail_template_ids: map(this.from.selected, 'template_id'),
          replace: this.to.replace,
          language: this.filters.language,
          new_language: this.to.language
        }, null, { entity_id: this.to.entity_id || this.from.entity_id }).then((resp) => {

          this.$notification.show = true
          this.$notification.message = `${startCase(this.method)} in Mail Templates is successful`
          this.$notification.type = 'success'
          this.$emit('edit', resp.data)

          if (confirmRes == 'close') {
            this.$emit('input')
          }
          this.loadMailTemplates()
        }).finally(() => {
          this.loading = false
        })
      },
    }
  }
</script>
